import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

var httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  private url = 'api/util';
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.url = baseUrl + this.url;
  }

  getToken(): string {
    var tokenJson = JSON.parse(localStorage.getItem('currentUser') || '');
    return tokenJson.token;
  }

  get(): Observable<any> {
    const apiurl = `${this.url}`;
    return this.http.get<any>(apiurl);
  }

  upload(file: File, data: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    const apiurl = `${this.url}/upload?data=${data}`;
    return this.http.post<any>(apiurl, formData, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }

  uploadFiles(files: File[], data: string): Observable<any> {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files[]', file);
    });

    const apiurl = `${this.url}/uploadFiles?data=${data}`;
    return this.http.post<any>(apiurl, formData, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }

  sendEmail(email: any): Observable<any> {
    const apiurl = `${this.url}/email`;
    return this.http.post<any>(apiurl, email);
  }

  getFiles(path: string): Observable<any> {
    const apiurl = `${this.url}/listFiles?directory=${path}`;
    return this.http.get<any>(apiurl, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }

  formatDateStr(date: Date) {
    const year = date.toLocaleString('default', { year: 'numeric' });
    const month = date.toLocaleString('default', {
      month: '2-digit',
    });
    const day = date.toLocaleString('default', { day: '2-digit' });

    return [year, month, day].join('');
  }
}
